import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import PuffLoader from "react-spinners/PuffLoader";
import styles from "./styles.module.scss";

const getDeviceType = () => {
  const width = window.innerWidth;
  if (width >= 1024) return "desktop";
  if (width >= 768) return "tablet";
  return "mobile";
};

const StatusManager = ({
  steps = [],
  initialStep = 0,
  isCancelled = false,
  stepClicked = (index, label) => {}, // Update default value to match expected arguments
  handleCancelOrder = () => {},
  onCompleteStep = () => {},
}) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loaderSize = {
    desktop: 55,
    tablet: 48,
    mobile: 40,
  }[deviceType];

  if (isCancelled) {
    return (
      <div className={styles.cancelledContainer}>
        <h3 className={styles.cancelledMessage}>Order Cancelled</h3>
        <FontAwesomeIcon
          icon={faXmark}
          className={styles.cancelledIcon}
        />
      </div>
    );
  }

  const isLastStepCompleted = currentStep === steps.length - 1;

  return (
    <div className={styles.statusManagerContainer}>
      <p className={styles.statusManagerTitle}>Status Manager</p>

      <div className={styles.tracker}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={`${styles.step} ${
              currentStep === index
                ? styles.active
                : currentStep > index
                ? styles.completed
                : styles.inactive
            }`}
          >
            <section className={styles.iconWrapper}>
              <div
                className={`${styles.completionLine} ${
                  currentStep >= index ? styles.filled : ""
                }`}
              ></div>

              {index === currentStep + 1 && (
                <div className={styles.loaderWrapper}>
                  <PuffLoader color="#154734" size={loaderSize} />
                </div>
              )}

              <div
                className={`${styles.iconContainer} ${
                  currentStep >= index
                    ? styles.activeIcon
                    : styles.inactiveIcon
                } ${index === currentStep + 1 ? styles.clickable : ""}`}
                onClick={() => {
                  if (index === currentStep + 1) {
                    if (step.key === "Complete" && typeof onCompleteStep === "function") {
                      onCompleteStep();
                    } else {
                      stepClicked(index, step.label);
                    }
                  }
                }}
              >
                {currentStep > index ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={styles.completedIcon}
                  />
                ) : (
                  step.icon
                )}
              </div>
            </section>
            <span className={styles.label}>{step.label}</span>
          </div>
        ))}
      </div>

      {!isLastStepCompleted && (
        <button onClick={handleCancelOrder} className={styles.cancelOrderButton}>
          Cancel Order
        </button>
      )}
    </div>
  );
};

export default StatusManager;
